export enum AssignmentGroupingType {
  manual = 0,
  automaticRandom = 1,
}

export enum AssignmentType {
  ManyGroups = 0, // Used to be called studentLed
  OneGroup = 1, // Used to be called instructorLed
}

export enum AssignmentState {
  unconfigured = -1,
  draft = 0,
  active = 1,
  canceled = 2,
}
